import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { publicApi } from "../../utils/publicApi";
import SiteHeader from "../../components/SiteHeader";
import SiteFooter from "../../components/SiteFooter";
import "./PublicCms.css";

const PublicPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setError("");
      try {
        const res = await publicApi({
          url: "admin/get-page-by-slug",
          method: "POST",
          body: { slug },
        });
        if (res.success && res.data) {
          setPage(res.data);
          document.title = `${res.data.title || slug} — AlphaXCloud`;
        } else {
          setPage(null);
          setError("Page not found");
          document.title = "Page not found";
        }
      } catch {
        setError("Could not load page");
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  return (
    <div className="public-cms cms-page site-theme">
      <SiteHeader />

      <main className="cms-main">
        {loading ? <p className="public-cms-muted cms-status">Loading…</p> : null}
        {error ? (
          <div className="cms-empty">
            <div className="public-cms-error">{error}</div>
            <Link className="cms-btn" to="/">
              Back to home
            </Link>
          </div>
        ) : null}

        {page ? (
          <>
            <header className="cms-page-hero">
              <p className="cms-page-eyebrow">AlphaXCloud</p>
              <h1>{page.title}</h1>
              {page.meta ? <p className="cms-page-lead">{page.meta}</p> : null}
            </header>
            <article
              className="public-cms-content cms-rich"
              dangerouslySetInnerHTML={{ __html: page.content }}
            />
          </>
        ) : null}
      </main>
      <SiteFooter />
    </div>
  );
};

export default PublicPage;
